@if ({
  product: product$ | async,
  component: component$ | async,
  displayComponent: displayComponent$ | async,
  isLogged: isLogged$ | async,
  }; as content) {
  @if (content.displayComponent) {
    <div class="conteiner-product-intro {{ content.component?.styleClasses }}">
      <h1>{{ content.product?.completeName }}</h1>
      <div class="box-content m-t-20">
        @if (content.product?.customerPartNumber) {
          <p>
            <strong>{{ 'intro.customer' | cxTranslate }}#: </strong><span>{{ content.product?.customerPartNumber }}</span>
          </p>
        }
        @if (content.product?.partNumber) {
          <p>
            <strong>{{ 'intro.part' | cxTranslate }}#: </strong><span>{{ content.product?.partNumber }}</span>
          </p>
        }
        @if (content.product?.catalogNumber) {
          <p>
            <strong>{{ 'intro.catalog' | cxTranslate }}#: </strong><span>{{ content.product?.catalogNumber }}</span>
          </p>
        }
        @if (content.product?.modelNumber) {
          <p>
            <strong>{{ 'intro.model' | cxTranslate }}#: </strong><span>{{ content.product?.modelNumber }}</span>
          </p>
        }
        @if (content.product?.nonReturnable) {
          <p class="d-flex align-items-center text-warning">
            <strong>{{ 'intro.nonReturnable' | cxTranslate }} </strong>
            <tooltip-icon [content]="'cart.cartItems.nonReturnableItemWarning' | cxTranslate"/>
          </p>
        }
        @if (content.product?.packagingWeight) {
          <p class="cel-weight">
            <strong>{{ 'intro.weight' | cxTranslate }}: </strong
              ><span>{{ content.product?.packagingWeight }} {{ content.product?.packagingWeightUom }}</span>
            </p>
          }
        </div>
      </div>
    }
  }
